import Profile from "../../../component/profilePage/profile";


export default function DeliveryProfile() {
    
  return (
    <div className=" px-8">
     <Profile />
    </div>
  );
}
